import axios from "axios"
import { Functions } from "./imports.utils"
import { createSessionErrorHandler } from "./session.utils"

export const instance = () => {
  let token = localStorage.getItem("token")
  const data = axios.create({
  baseURL: Functions.getBaseURL()+"/api/v1/",
    headers: {
        "authorization" :token || ""
    }
  })
  // A 401 on an authenticated request means the session is gone: clear it and go to /login.
  data.interceptors.response.use((response) => response, createSessionErrorHandler())
  return data
}
